export default {
  palm: 479,
  tab: 768,
  fullHeader: 820,
  lap: 1024,
  desk: 1280,
};
